import React from 'react';
import { motion } from 'framer-motion';

const MenuHighlights = () => {
  const featuredDishes = [
    {
      id: 1,
      name: 'Parrillada de Mariscos',
      description: 'Una abundante selección de mariscos frescos a la parrilla con limón, ajo y hierbas aromáticas.',
      price: '$28.990',
      image: '/src/assets/images/placeholder-dish1.jpg',
      tags: ['Popular', 'Para compartir'],
    },
    {
      id: 2,
      name: 'Ceviche Mixto',
      description: 'Pescado blanco, camarones y pulpo marinados en limón fresco con cebolla morada, cilantro y ají.',
      price: '$15.990',
      image: '/src/assets/images/placeholder-dish2.jpg',
      tags: ['Clásico'],
    },
    {
      id: 3,
      name: 'Empanadas de Jaiba',
      description: 'Empanadas artesanales rellenas de jaiba chilena, cebolla caramelizada y queso.',
      price: '$9.990',
      image: '/src/assets/images/placeholder-dish3.jpg',
      tags: ['Casero'],
    },
    {
      id: 4,
      name: 'Arroz Marinero',
      description: 'Arroz cremoso preparado con variedad de mariscos, vino blanco y azafrán.',
      price: '$18.990',
      image: '/src/assets/images/placeholder-dish4.jpg',
      tags: ['Tradicional', 'Especialidad'],
    },
  ];

  return (
    <section id="menu" className="py-20 bg-white relative">
      {/* Elementos decorativos de olas en el fondo */}
      <div className="absolute top-0 left-0 right-0 h-12 bg-gradient-to-b from-marina-50 to-white"></div>
      
      <div className="container mx-auto px-4 md:px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="section-title inline-block text-center">Nuestros Platos Destacados</h2>
          <p className="text-lg text-gray-600 mt-6 max-w-2xl mx-auto">
            Cada plato es una obra maestra culinaria elaborada con los mariscos más frescos traídos diariamente a nuestra cocina.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
          {featuredDishes.map((dish, index) => (
            <motion.div
              key={dish.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              viewport={{ once: true }}
              className="card flex flex-col md:flex-row overflow-hidden"
            >
              <div className="w-full md:w-2/5 h-56 md:h-auto relative">
                <div className="absolute inset-0 bg-marina-300" style={{
                  backgroundImage: `url(${dish.image})`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center'
                }}>
                  <div className="absolute inset-0 bg-gradient-to-br from-marina-900/20 to-marina-900/40"></div>
                </div>
                {dish.tags && dish.tags.length > 0 && (
                  <div className="absolute top-3 left-3 flex flex-wrap gap-2">
                    {dish.tags.map((tag, idx) => (
                      <span 
                        key={idx} 
                        className="text-xs font-medium bg-marina-600 text-white px-2 py-1 rounded-md"
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                )}
              </div>
              <div className="w-full md:w-3/5 p-6 flex flex-col justify-between">
                <div>
                  <h3 className="text-xl font-bold mb-2">{dish.name}</h3>
                  <p className="text-gray-600 mb-4">{dish.description}</p>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-xl font-bold text-marina-700">{dish.price}</span>
                  <button className="btn-primary py-1 px-4 text-sm">
                    Ordenar
                  </button>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.4 }}
          viewport={{ once: true }}
          className="mt-12 text-center"
        >
          <button className="btn-secondary">
            Ver Menú Completo
          </button>
        </motion.div>
      </div>
    </section>
  );
};

export default MenuHighlights;
